// src/services/api.js
import axios from "axios";

const API_URL = "/api"; // URL base relativa para usar proxy
const AUTH_TOKEN_KEY = "authToken"; // Constante para a chave do token no localStorage

// Função para realizar o login
export const loginUser = async (credentials) => {
  try {
    // Faz a requisição POST para o endpoint de login com as credenciais do usuário
    console.log(`Enviando requisição de login para: ${API_URL}/auth/login`); // Corrigido aqui
    const response = await axios.post(`${API_URL}/auth/login`, credentials, {
      timeout: 6000, // Timeout para evitar que a requisição fique pendente indefinidamente
    });

    // Verifica se a resposta contém o token
    if (response.data.token) {
      // Armazena o token no localStorage para uso futuro
      localStorage.setItem(AUTH_TOKEN_KEY, response.data.token);
    }

    // Retorna os dados da resposta, incluindo o token
    return response.data;
  } catch (error) {
    // Se houver um erro, trata diferentes tipos de erros
    if (error.response) {
      // Erro de resposta do servidor
      const message = error.response.data.error || "Erro ao fazer login.";
      console.error("Erro na resposta do servidor:", message); // Log do erro
      throw new Error(message);
    } else if (error.request) {
      // Erro de rede ou servidor não respondeu
      console.error("Erro de rede:", error.message); // Log de erro de rede
      throw new Error("Erro de rede. Verifique sua conexão ou se o servidor está rodando.");
    } else if (error.code === 'ECONNABORTED') {
      // Erro de timeout
      console.error("Erro de timeout:", error.message); // Log de erro de timeout
      throw new Error("A requisição excedeu o tempo limite. Tente novamente.");
    } else {
      // Outros erros, como configuração incorreta
      console.error("Erro desconhecido:", error.message); // Log de erro desconhecido
      throw new Error(error.message || "Erro desconhecido ao fazer login.");
    }
  }
};

// Função para obter o token armazenado
export const getAuthToken = () => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
};

// Função para remover o token (logout)
export const logoutUser = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
};

// 🔹 Iniciar pagamento M-Pesa
export const iniciarPagamento = async (dados) => {
  try {
    const response = await axios.post(`${API_URL}/portal/pagamento`, dados, {
      headers: {
        "Content-Type": "application/json"
      },
      timeout: 60000
    });

    return response.data;

  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "Erro ao iniciar pagamento.");
    } else if (error.request) {
      throw new Error("Servidor não respondeu.");
    } else {
      throw new Error(error.message);
    }
  }
};
